import { render, staticRenderFns } from "./ReferencesTab.vue?vue&type=template&id=297c0a13&scoped=true&"
import script from "./ReferencesTab.vue?vue&type=script&lang=js&"
export * from "./ReferencesTab.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesTab.vue?vue&type=style&index=0&id=297c0a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c0a13",
  null
  
)

export default component.exports